import { FIELD_IS_REQUIRED } from 'const'
import { MAX_COMMENTS_LENGTH, ShareType } from 'features/Share/models/shareForm'
import * as z from 'zod'
import { array, object, string, TypeOf } from 'zod'

export enum NoteType {
  PERSONAL = 'personal',
  SHARED = 'shared',
}

export const noteTypeOptions = [
  { label: 'Note', value: NoteType.PERSONAL },
  { label: 'Shared Note', value: NoteType.SHARED },
]

/**
 * Create/edit note form. The share fields (`type`, `members`, `comments`) are only
 * meaningful when `noteType === NoteType.SHARED`; they are validated conditionally
 * and ignored on submit for personal notes.
 */
export const noteFormSchema = object({
  subject: string().min(1, FIELD_IS_REQUIRED).max(50, 'Maximum length is 50 characters'),
  body: string().min(1, FIELD_IS_REQUIRED).max(200, 'Maximum length is 200 characters'),
  link: string().refine((value) => {
    if (value === '') {
      return true
    }
    return /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/.test(
      value,
    )
  }, 'Link has incorrect format'),
  noteType: z.nativeEnum(NoteType),
  type: string(),
  members: array(
    object({
      label: string(),
      value: string(),
    }),
  ),
  comments: z
    .string()
    .max(MAX_COMMENTS_LENGTH, `Max message length is ${MAX_COMMENTS_LENGTH} characters`)
    .optional(),
}).superRefine((values, ctx) => {
  if (
    values.noteType === NoteType.SHARED &&
    values.type === ShareType.MEMBERS &&
    values.members.length === 0
  ) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['members'],
      message: 'Please select at least one member',
    })
  }
})

export type NoteFormValues = TypeOf<typeof noteFormSchema>
